import { AccountPosition } from '../../type';

export const filterPositionLiquidities = (position: AccountPosition) => position['GES_ESTIM_D.MC_ESTIMTYPE'] === 'ESPECES';
